/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown>, organisation: NonNullable<unknown> }} Pilot_Ended_BodyInputs */



/**
* | output |
* | --- |
* | "The {weeks} weeks with {organisation} are over. Your account is closed. Your practice conversations and preparations are no longer available." |
*
* @param {Pilot_Ended_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const pilot_ended_body = /** @type {((inputs: Pilot_Ended_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pilot_Ended_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`De ${i?.weeks} weken met ${i?.organisation} zitten erop. Je account is afgesloten. Je oefengesprekken en voorbereidingen zijn niet meer beschikbaar.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Les ${i?.weeks} semaines avec ${i?.organisation} sont terminées. Votre compte est clôturé. Vos conversations d’entraînement et vos préparations ne sont plus disponibles.`)
	return /** @type {LocalizedString} */ (`The ${i?.weeks} weeks with ${i?.organisation} are over. Your account is closed. Your practice conversations and preparations are no longer available.`)
});